import React from 'react';

type TextParserProps = {
    text: string;
}

const TextParser = ({text}: TextParserProps) => {
    if (typeof text !== 'string') {
        return text;
    }
    return <>
        {
            text.split(/\*\*(.*?)\*\*/g).map((it, idx) => {
                if (idx % 2 === 0) {
                    return <React.Fragment key={idx}>{it}</React.Fragment>
                }
                return <strong className="bg-highlight-gradient" key={idx}>{it}</strong>
            })
        }
    </>
}

export default TextParser;
